export default function BuildTable(coverageToolResultsView, plans) {
    // View
    const table = coverageToolResultsView.querySelector("table");
    const tbody = table.querySelector("tbody");
    // const table = coverageToolResultsView.getElementsByTagName("table")[0];
    // const tbody = table.getElementsByTagName("tbody")[0]; // Reset table

    tbody.innerHTML = "";

    if (plans.length < 11) coverageToolResultsView.classList.add("results__view--show-all");

    for (let i = plans.length - 1; i >= 0; i--) {
        const plan = plans[i];
        let coverageHTML = "";
        let priorAuthHTML = "";
        let stepTherapyHTML = "";
        let detailLinkHTML = "";

        switch (plan.Covered) {
            case false:
                coverageHTML = '<span class="glyphicon glyphicon-remove"></span><span class="asterisk">*</span>';
                break;

            case "unknown":
                coverageHTML = "Unspecified ";
                break;

            default:
                coverageHTML = '<span class="glyphicon glyphicon-ok"></span>';
        }

        if (plan.Covered) {
            priorAuthHTML = !plan.PriorAuthorization ? '<span class="glyphicon glyphicon-remove"></span>' : '<span class="glyphicon glyphicon-ok"></span>';
            stepTherapyHTML = !plan.StepTherapy ? '<span class="glyphicon glyphicon-remove"></span>' : '<span class="glyphicon glyphicon-ok"></span>';
            detailLinkHTML = `<button\n class="btn btn-default trigger-coverage-details"\n delete-data-toggle="modal"\n delete-data-target="#modalCoverageDetails"\n data-plan="${plan.Name}"\n data-cbsaShortName="${plan.CBSAShortName}"\n data-stateShort="${plan.StateId}"\n data-channelId="${plan.ChannelId}"\n data-productId="${plan.ProductId}"\n data-formularyId="${plan.FormularyId}"\n data-indicationId="${plan.IndicationId}"\n data-indicationName="${plan.IndicationName}">Details<span class="fa fa-long-arrow-alt-right"></span></button>`;
        }

        if (!plan.PriorAuthorization && !plan.StepTherapy) detailLinkHTML = ""; // Build table row

        const result = `<tr>\n<td>${plan.Name}</td>\n<td>${coverageHTML}</td>\n<td>${priorAuthHTML}</td>\n<td>${stepTherapyHTML}</td>\n<td>${detailLinkHTML}</td>\n</tr>`; // Insert into table

        tbody.insertAdjacentHTML("afterbegin", result);
    }
}
